import React, { FunctionComponent } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './CardHeader.module.css';

export enum HorizontalAlignment {
  Left = 'left',
  Center = 'center',
  Right = 'right'
}

export type CardHeaderProps = {
  textAlignment?: HorizontalAlignment;
};

export const CardHeader: FunctionComponent<CardHeaderProps> = React.memo(
  (props) => {
    const {
      textAlignment = HorizontalAlignment.Left,
      children,
      ...remainingProps
    } = prepareProps({ props });

    return (
      <header
        {...remainingProps}
        className={classes(
          styles.header,
          textAlignmentToClassName[textAlignment]
        )}
      >
        {children}
      </header>
    );
  }
);

const textAlignmentToClassName: Record<HorizontalAlignment, string | null> = {
  left: styles.alignLeft,
  center: styles.alignCenter,
  right: styles.alignRight
};
